import React, {FC} from 'react';
import styled from 'styled-components';

import {DropdownItemProps} from '../../../../../../libs/shared/ui/src/components/dropdowns/dropdownItem';
import {SimpleDropdownItem} from '../../../../../../libs/shared/ui/src/components/dropdowns/simpleDropdownItem';
import {fonts} from '../../../../../../libs/shared/ui/src/styles/fontStyles';
import {RegexPart} from '../../../../editors/commons/stringTemplateModel';
import {
  getLabelForRegexCharClass,
  getSourceForRegexCharClass,
} from '../../../../editors/expressions/expressionLabels';

const StyledSourceSpan = styled.span`
  font-size: 10px;
  font-weight: 700;
  color: ${(p) => p.theme.palette.blue.shade40};
  background-color: ${(p) => p.theme.palette.blue.shade20};
  padding: 3px 5px;
  font-family: ${fonts.monospace};
`;

export interface RegexPartDropdownItemProps extends DropdownItemProps {
  part: RegexPart;
}

export const RegexPartDropdownItem: FC<RegexPartDropdownItemProps> = ({part, ...rest}) => (
  <SimpleDropdownItem {...rest}>
    {getLabelForRegexCharClass(part.char)}
    &nbsp;
    <StyledSourceSpan>{getSourceForRegexCharClass(part.char)}</StyledSourceSpan>
  </SimpleDropdownItem>
);
